import React from "react"
import PropTypes from "prop-types"
import DateHelper from "helpers/date"
import styles from "./BroadcastListItem.css"
import classNames from "classnames"
import get from "lodash/get"

function BroadcastListItem({ broadcast, type, onClick }) {
  const logo = get(broadcast, ["channel", "data", "image_bundle", "logo_player", "small"])
  const channel = broadcast.getChannel()
  const programBroadcastDate = DateHelper.humanDate(broadcast.getStartAt(), false)
  const dateTime = DateHelper.getMicroDataDate(broadcast.getStartAt())

  return (
    <article className={styles.itemContainer}>
      <header className={styles.broadcastItemLogo}>{logo && <img src={logo.url} alt={channel.data.title} />}</header>

      <section className={styles.broadcastItemSectionContent}>
        <div className={styles.broadcastItemContainerDateContent}>
          <time className={styles.broadcastItemContainerDate} dateTime={dateTime}>
            {programBroadcastDate}
          </time>
        </div>

        <div className={styles.broadcastItemContent}>
          <h3 className={styles.broadcastItemTitle}>
            {broadcast.getSubtitle() && `${broadcast.getSubtitle()} - `}
            {broadcast.getTitle()}
          </h3>
          <p className={styles.broadcastItemDescription}>{broadcast.getDescription()}</p>
        </div>
      </section>
      <button
        title={type === "play" ? "Regarder" : "Enregistrer"}
        type="button"
        className={classNames(styles.broadcastItemSection, styles.broadcastItemRecordLogo)}
        aria-label="More options"
        onClick={onClick}
      >
        {type === "play" ? (
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="16" cy="16" r="16" fill="#FFC107" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.3334 21.02V11.0632C12.3334 10.6831 12.6519 10.375 13.0448 10.375C13.1737 10.375 13.3002 10.4089 13.4108 10.4731L21.9879 15.4515C22.3248 15.647 22.434 16.0698 22.2319 16.3957C22.1718 16.4926 22.088 16.5736 21.9879 16.6318L13.4108 21.6102C13.0739 21.8057 12.6369 21.7 12.4348 21.3741C12.3684 21.2671 12.3334 21.1448 12.3334 21.02Z"
              fill="black"
            />
          </svg>
        ) : (
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16 29.3333C8.63619 29.3333 2.66666 23.3638 2.66666 16C2.66666 8.63619 8.63619 2.66666 16 2.66666C23.3638 2.66666 29.3333 8.63619 29.3333 16C29.3333 23.3638 23.3638 29.3333 16 29.3333Z"
              fill="white"
              fillOpacity="0.9"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16 22.6667C19.6819 22.6667 22.6667 19.6819 22.6667 16C22.6667 12.3181 19.6819 9.33334 16 9.33334C12.3181 9.33334 9.33334 12.3181 9.33334 16C9.33334 19.6819 12.3181 22.6667 16 22.6667Z"
              fill="#F93B25"
            />
          </svg>
        )}
      </button>
    </article>
  )
}

BroadcastListItem.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.oneOf(["play", "record"]).isRequired,
  broadcast: PropTypes.shape({
    getStartAt: PropTypes.func.isRequired,
    getChannel: PropTypes.func.isRequired,
    getId: PropTypes.func.isRequired,
    getSubtitle: PropTypes.func,
    getTitle: PropTypes.func.isRequired,
    getDescription: PropTypes.func.isRequired,
    channel: PropTypes.shape({
      data: PropTypes.shape({
        image_bundle: PropTypes.shape({
          logo_player: PropTypes.shape({
            small: PropTypes.shape({
              url: PropTypes.string.isRequired,
            }).isRequired,
          }).isRequired,
        }).isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
}

export default BroadcastListItem
